export const MAX_CONTEXTS = 6
